export const downloadFileAsBlob = (bites, fileName) => {
  const linkSource = window.URL.createObjectURL(new Blob([bites]))
  const downloadLink = document.createElement('a')

  downloadLink.href = linkSource
  downloadLink.download = fileName
  document.body.appendChild(downloadLink)
  downloadLink.click()
}
